import { Component, Emit, Vue, Prop } from "vue-property-decorator";
import MyButton from "@/components/MyButton.vue";

@Component({
	components: { MyButton }
})
export default class Confirmation extends Vue {
	@Prop() public title!: string;
	@Prop() public message!: string;
	@Prop() public okButtonDisabled!: boolean;
	@Prop() public cancelButtonDisabled!: boolean;
	public created(): void { }
	@Emit("ok")
	public ok(): void { }
	@Emit("cancel")
	public cancel(): void { }

	private onOkClick(): void {
		this.ok();
	}
	private onCancelClick(): void {
		this.cancel();
	}
}
